// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-dialog-content {
   width: 400px
}

mat-form-field {
   display: block;
}

/*::ng-deep .mat-form-field { width: 320px }*/
.text-center {
   text-align: center;
}

.div_show_qr {
   font-size: 13px;
   margin-top: 32px;
   margin-bottom: -10px;
   text-align: center;
}

a {
   color: #00bcd4;
   cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/app/account/twofactor/twofactor.component.css"],"names":[],"mappings":"AAAA;GACG;AACH;;AAEA;GACG,cAAc;AACjB;;AAEA,6CAA6C;AAC7C;GACG,kBAAkB;AACrB;;AAEA;GACG,eAAe;GACf,gBAAgB;GAChB,oBAAoB;GACpB,kBAAkB;AACrB;;AAEA;GACG,cAAc;GACd,eAAe;AAClB","sourcesContent":["mat-dialog-content {\n   width: 400px\n}\n\nmat-form-field {\n   display: block;\n}\n\n/*::ng-deep .mat-form-field { width: 320px }*/\n.text-center {\n   text-align: center;\n}\n\n.div_show_qr {\n   font-size: 13px;\n   margin-top: 32px;\n   margin-bottom: -10px;\n   text-align: center;\n}\n\na {\n   color: #00bcd4;\n   cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
